(function () {

  'use strict';

  angular.module('sempraWebapp').factory('invariant', invariantService);

  /** @ngInject */
  function invariantService() {

    var invariant = function (condition, format, a, b, c, d, e, f) {
      if (angular.isUndefined(format)) {
        throw new Error('invariant requires an error message argument');
      }

      if (!condition) {
        var error;
        if (angular.isUndefined(format)) {
          error = new Error(
            'Minified exception occurred; use the non-minified dev environment ' +
            'for the full error message and additional helpful warnings.'
          );
        } else {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;
          error = new Error(
            'Invariant Violation: ' +
            format.replace(/%s/g, function () {
              return args[argIndex++];
            })
          );
        }

        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
      }
    };

    return invariant;
  }
})();
